(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("RLogin", [], factory);
	else if(typeof exports === 'object')
		exports["RLogin"] = factory();
	else
		root["RLogin"] = factory();
})(this, () => {
return 